The icon to indicate candidate identity has been verified, including the images and tooltip label.
